require('../../modules/es.typed-array.from');
